import { render, staticRenderFns } from "./view-entity.vue?vue&type=template&id=f8664750&scoped=true"
import script from "./view-entity.vue?vue&type=script&lang=js"
export * from "./view-entity.vue?vue&type=script&lang=js"
import style0 from "./view-entity.vue?vue&type=style&index=0&id=f8664750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8664750",
  null
  
)

export default component.exports